import {
  Component,
  Input,
  OnDestroy,
  OnInit,
  inject,
  Inject,
  PLATFORM_ID,
} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { destinationCard } from './interface';
import { FormArray, FormGroup, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { HomePageService } from '../../../shared/services/home-page/services/home-page.service';
import { FlightSearchService } from '../../../shared/services/flight-search/services/flight-search.service';
import { SharedService } from '../../../shared/services/shared.service';
import { PopularAirlinesSharedService } from '../../popular-airlines/services/popular-airlines-shared.service';
import { PopularAirlinesService } from '../../popular-airlines/services/popular-airlines.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-top-destination',
  templateUrl: './top-destination.component.html',
  styleUrls: ['./top-destination.component.scss'],
})
export class TopDestinationComponent implements OnInit, OnDestroy {
  private isBrowser: boolean;

  translate = inject(TranslateService);
  flightSearch = inject(FlightSearchService);
  homePageService = inject(HomePageService);
  sharedService = inject(SharedService);
  popularAirlinesService = inject(PopularAirlinesService);
  popularAirlinesSharedService = inject(PopularAirlinesSharedService);
  router = inject(Router);

  langIndex: number = 0;
  cards: Array<destinationCard> = [];
  currency?: string;
  date?: object;
  @Input() destinationView?: boolean;
  subscriptions: Subscription = new Subscription();

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  ngOnInit(): void {
    this.popularAirlinesService.getAllAirlines();

    this.subscriptions.add(
      this.translate.onLangChange.subscribe((event) => {
        this.updateLangIndex(event.lang);
      }),
    );

    // Initialize langIndex with the current language
    this.updateLangIndex(this.translate.currentLang);
  }

  gotoSearchResult(card: destinationCard): void {
    if (!this.isBrowser) {
      return; // Exit if running on the server
    }

    const currentDate = new Date(); // Get current date
    currentDate.setDate(currentDate.getDate() + 7); // Add 7 days after current date

    this.flightSearch.changeFlightType('OneWay'); // Set flight type to OneWay

    // Make the flight array empty, then add the flight from Kuwait to the selected destination
    this.flightSearch.flightsArray.clear();
    (<FormArray>this.flightSearch.searchFlight.get('Flights')).push(
      new FormGroup({
        departing: new FormControl('Cairo,CAI'),
        landing: new FormControl(`${card.distination},${card.airportCode}`),
        departingD: new FormControl(currentDate.toDateString()),
      }),
    );

    this.currency = this.homePageService.selectedCurrency.Currency_Code;
    const resultLink = this.flightSearch.getSearchresultLink(
      this.translate.currentLang,
      this.currency,
      this.translate.currentLang,
      1,
      ',',
      this.popularAirlinesSharedService.preferredAirlineIatacode,
    );

    if (resultLink) {
      const splittedLink = resultLink.toString().split('/');

      // Navigate to search result
      this.router.navigate([
        '/flightResult',
        splittedLink[0],
        splittedLink[1],
        splittedLink[2],
        splittedLink[3],
        splittedLink[4],
        splittedLink[5],
        splittedLink[6],
        splittedLink[7],
        splittedLink[8],
        splittedLink[9],
      ]);

      // Save form data to localStorage (browser only)
      if (this.isBrowser) {
        localStorage.setItem(
          'form',
          JSON.stringify(this.flightSearch.searchFlight.value),
        );
      }
    }
  }

  get airlines() {
    return this.popularAirlinesService.airlines;
  }

  updateLangIndex(currentLang: string): void {
    this.langIndex =
      currentLang === 'en' ? 0 : currentLang === 'ar' ? 1 : this.langIndex;
  }

  generateAirlineLink(slug: string): string[] {
    const lang = this.translate.currentLang;
    return ['/', 'airlines', slug];
  }

  ngOnDestroy(): void {
    // Unsubscribe to avoid memory leaks
    this.subscriptions.unsubscribe();
  }
}
